import AffiliationsInfo from './AffiliationsInfo';

export default AffiliationsInfo;
